<template>
  <div :id="componentId" class="sp1-media-cooperation" :style="sectionStyle">
    <div class="media-grid">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['media-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img
          class="media-logo"
          referrerpolicy="no-referrer"
          :src="item.imageUrl"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaCooperation',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_15'
    }
  },
  data() {
    return {
      backgroundImage: require('../assets/img/bottom_bg.png'),
      items: [
        { imageUrl: require('../assets/img/media_1.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../assets/img/media_2.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/2' },
        { imageUrl: require('../assets/img/media_3.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../assets/img/media_4.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/4' },
        { imageUrl: require('../assets/img/media_5.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../assets/img/media_6.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/6' }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-media-cooperation {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  width: 1400px;
  margin-top: 30px;
  gap: 20px 16px;
}

.media-item {
  width: 220px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px dashed rgba(238, 238, 238, 1);
  background-color: rgba(255, 255, 255, 1);
}

.media-item.is-link {
  cursor: pointer;
}

.media-item.is-link:hover {
  opacity: 0.9;
}

.media-logo {
  max-width: 180px;
  max-height: 80px;
  object-fit: contain;
}
</style>
